import { errorMsg } from '../constants/messages';

const contactFormFormData = [
  {
    name: 'id',
    label: 'ID',
    fieldType: {
      name: 'text',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Id', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },
  {
    title: 'Contact Form Details',
    name: 'name',
    label: 'Full Name',
    fieldType: {
      name: 'text',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Full Name', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'countryCode',
    label: 'Country Code',
    fieldType: {
      name: 'text',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Country Code' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'contactNumber',
    label: 'Contact Number',
    fieldType: {
      name: 'text',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Contact Number' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
  {
    name: 'email',
    label: 'E-mail',
    fieldType: {
      name: 'email',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'E-mail' },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'reasonForContact',
    label: 'Reason For Contact',
    fieldType: {
      name: 'text',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Reason For Contact' },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'clientType',
    label: 'Client Type',
    fieldType: {
      name: 'text',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Client Type' },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'createdAt',
    label: 'Date Of Submission',
    fieldType: {
      name: 'text',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Date Of Submission' },
    isTableHeader: true,
    isAccordian: true,
  },
  {
    name: 'message',
    label: 'message',
    fieldType: {
      name: 'textarea',
    },
    required: true,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'message' },
    isTableHeader: false,
    isAccordian: true,
  },
  {
    name: 'lastStatus',
    label: 'Last Status',
    fieldType: {
      name: 'select',
      options: [
        { id: 'Duplicate', name: 'Duplicate', value: 'Duplicate' },
        { id: 'Contacted', name: 'Contacted', value: 'Contacted' },
        {
          id: 'Incorrect Information',
          name: 'Incorrect Information',
          value: 'Incorrect Information',
        },
        { id: 'Closed', name: 'Closed', value: 'Closed' },
      ],
    },
    required: false,
    readonly: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Last Status' },
    isTableHeader: true,
    isAccordian: true,
    default: '',
  },
];

export { contactFormFormData };
